// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__lbada","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3Vq9T"};